/*
* Copyright (C) Regione Lombardia
*/
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CoreRuoloAmministratoreGuard } from '@core/guards/ruolo-amministratore.guard';
import { PagesGestioneOperaCreaOperaComponent } from './crea-opera/crea-opera.component';
import { PagesGestioneOperaCreaOperaResolver } from './crea-opera/crea-opera.resolver';
import { PagesGestioneOperaDettaglioOperaComponent } from './dettaglio-opera/dettaglio-opera.component';
import { PagesGestioneOperaDettaglioOperaResolver } from './dettaglio-opera/dettaglio-opera.resolver';
import { PagesGestioneOperaModificaOperaComponent } from './modifica-opera/modifica-opera.component';
import { PagesGestioneOperaModificaOperaResolver } from './modifica-opera/modifica-opera.resolver';
import { PagesGestioneOperaRicercaOperaComponent } from './ricerca-opera/ricerca-opera.component';
import { PagesGestioneOperaRicercaOperaResolver } from './ricerca-opera/ricerca-opera.resolver';

@NgModule({
    imports: [RouterModule.forChild([
        {
            path: 'ricerca',
            component: PagesGestioneOperaRicercaOperaComponent,
            resolve: { additionalInformation: PagesGestioneOperaRicercaOperaResolver },
            data: {
                pageType: 'ricerca'
            },
        },
        {
            path: 'approva-opera',
            component: PagesGestioneOperaRicercaOperaComponent,
            resolve: { additionalInformation: PagesGestioneOperaRicercaOperaResolver },
            canActivate: [ CoreRuoloAmministratoreGuard ],
            data: {
                pageType: 'approva-opera'
            },
        },
        {
            path: 'dettaglio/:idOpera', 
            component: PagesGestioneOperaDettaglioOperaComponent,
            resolve: { additionalInformation: PagesGestioneOperaDettaglioOperaResolver },
        },
        {
            path: 'dettaglio/:idOpera/modifica', 
            component: PagesGestioneOperaModificaOperaComponent,
            resolve: { additionalInformation: PagesGestioneOperaModificaOperaResolver },
        },
        {
            path: 'crea',
            component: PagesGestioneOperaCreaOperaComponent,
            resolve: { additionalInformation: PagesGestioneOperaCreaOperaResolver },
        },
        { path: '**', redirectTo: 'ricerca' },
    ])],
    exports: [
        RouterModule,
    ]
})
export class PagesGestioneOperaRoutingModule { }
